module.exports = __webpack_public_path__ + "static/img/null.ce7db3dc.png";